<!-- 联系我们 -->
<template>
  <div id="contactUs" name="contactUs">
    <!-- 联系卡片 -->
    <div v-for="(item, index) in contactsData" :key="index" class="contactCard">
      <!-- 二维码 -->
      <div class="qrCode" :style="{ borderColor: item.boxColor,boxShadow: '7px 7px 0px 0px ' + item.boxShaColor }">
        <!-- <img :src="item.qrCode"> -->
        <div class="demo-image__preview">
          <el-image
            v-if="item.qrCode"
            style="width: 100px; height: 100px"
            :src="item.qrCode"
            :preview-src-list="[item.qrCode]"
          />
          <div v-else class="noImage">
            暂无图片
          </div>
        </div>
      </div>
      <!-- 二维码 end -->

      <!-- 联系信息 -->
      <div class="textInfo">
        <p class="name">{{ item.name }}</p>
        <p class="phone">
          <span
            class="el-icon-mobile-phone"
            :style="{ color: item.boxColor }"
          />
          {{ item.phone }}
        </p>
      </div>
      <!-- 联系信息 end -->

      <!-- 椭圆背景 -->
      <div
        class="ellipse-bg"
        :style="{ background: item.bgcolor }"
      >
        <span
          class="ellipse-line"
        />
      </div>
      <!-- 椭圆背景 end -->
    </div>
    <!-- 联系卡片 end -->
  </div>
</template>
<script>
import { queryStoreTitleTypeInfo } from '@/api/shop.js'
export default {
  data() {
    return {
      contactsData: [

      ],

      colorList: [
        //   颜色集合
        { boxColor: '#4789F5', bgcolor: '#F1F6FF', boxShaColor: 'rgba(66, 133, 244, 0.3)' },
        { boxColor: '#FE9F45', bgcolor: '#FEF6ED', boxShaColor: 'rgba(254, 159, 69, 0.3)' },
        { boxColor: '#FF6A6A', bgcolor: '#FFEEEF', boxShaColor: 'rgba(255, 106, 106, 0.3)' },
        { boxColor: '#54CDE8', bgcolor: '#ECF9FF', boxShaColor: 'rgba(84, 205, 232, 0.3)' },
        { boxColor: '#17D5B5', bgcolor: '#E5FAFF', boxShaColor: 'rgba(25, 214, 182, 0.3)' }
      ]
    }
  },

  created() {
    // this.setColor()
    this.onSearch()
  },

  methods: {
    onSearch() {
      const { fid, forder, storeId } = this.$route.query
      const params = new URLSearchParams()
      params.append('FMallStoreId', storeId)
      params.append('StorePageNavigationFID', fid)
      params.append('StorePageNavigationFOrder', forder)
      queryStoreTitleTypeInfo(params)
        .then(res => {
          this.contactsData = []
          res.data.forEach(item => {
            const obj = {
              qrCode: item.fqrCodePath,
              name: item.flinkman,
              phone: item.ftelNo
            }
            this.contactsData.push(obj)
          })
          this.setColor()
        })
    },
    setColor() {
      // 遍历联系人数据
      this.contactsData.forEach((item, index) => {
        //   将颜色数据添加到联系人数据中,循环渲染数据,设置颜色
        // 当index == 颜色数组长度,颜色数组从头开始添加
        item.boxColor = this.colorList[index % this.colorList.length].boxColor
        item.bgcolor = this.colorList[index % this.colorList.length].bgcolor
        item.boxShaColor = this.colorList[index % this.colorList.length].boxShaColor
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#contactUs {
    .noImage {
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      background: #f5f7fa;
      font-size: 14px;
  }
  width: 100%;
  background: #ffffff;
  padding: 22px 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 20px 0;
  .contactCard {
    //联系卡片样式
    width: 374px;
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 2px 18px 0px rgba(50, 50, 50, 0.1);
    border-radius: 2px;
    padding: 34px 0 27px 21px;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-right: 20px;
    margin-bottom: 20px;
    .qrCode,
    .textInfo {
      z-index: 2000;
    }

    .qrCode {
      // 二维码样式
      width: 112px;
      height: 112px;
      background: #bed5fd;
      border: 6px solid;
      border-radius: 5px;
      margin-right: 25px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .textInfo {
      // 文字信息样式
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .name {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .phone {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #666666;
      }
    }
  }

  .contactCard:nth-child(3n + 3) {
    margin-right: 0;
  }
  .ellipse-bg {
    width: 319px;
    height: 95px;
    border-radius: 50px 50px 0;
    position: absolute;
    bottom: -5px;
    right: -10px;
  }
  .ellipse-line{
    display: block;
    width: 48px;
    height: 3px;
    background: #ffffff;
    position: absolute;
    top: 10px;
    left: 95px;
  }
}
</style>
